import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useCookies } from 'react-cookie';

const useApplicationSession = () => {
    const [token, setToken] = useState(undefined);
    const [cookies] = useCookies(['SESSION']);
    const history = useHistory();
    useEffect(() => {
        if (cookies.SESSION === undefined) {
            history.push('/');
            window.location.reload(false);
        } else if (cookies.SESSION.access_token === undefined) {
            history.push('/');
            window.location.reload(false);
        }
        const { token_type, access_token } = cookies.SESSION;
        const token = `${token_type} ${access_token}`;
        setToken(token);
    }, [history, cookies]);

    return token;
};

export default useApplicationSession;
